import { render, staticRenderFns } from "./TheMaterial.vue?vue&type=template&id=0922e7aa&scoped=true&"
import script from "./TheMaterial.vue?vue&type=script&lang=js&"
export * from "./TheMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922e7aa",
  null
  
)

export default component.exports